import utils from "@/components/declarations/validators/utils";

export default {
  isValid(self) {
    const errors = {
      atLeastOne: false,
      multiFamilyCount: false,
      temporaryCount: false,
      premisesCount: false,
      isAllPremises: false,
      atLeastOneBuildingType: false
    };
    self.setErrors(errors);

    let text = "";
    if (self.declarationType === "A") {
      if (self.singleOrMultiFamily === "multi" && (isNaN(parseInt(self.multiFamilyCount)) || self.multiFamilyCount <= 0)) {
        errors.multiFamilyCount = true;
        errors.atLeastOne = true;
        text += "Prosimy o podanie liczby wszystkich lokali mieszkalnych w budynku. <br/>";
      }

      if (self.singleOrMultiFamily === "isTemporary" && (isNaN(parseInt(self.temporaryCount)) || self.temporaryCount <= 0)) {
        errors.temporaryCount = true;
        errors.atLeastOne = true;
        text += "Prosimy o podanie liczby wszystkich lokali zbiorowego zamieszkania w budynku. <br/>"
      }

      if (!self.isAllPremises && (isNaN(parseInt(self.premisesCount)) || self.premisesCount <= 0)) {
        errors.premisesCount = true;
        errors.atLeastOne = true;
        text += "Prosimy o podanie liczby lokali mieszkalnych / zbiorowego zamieszkania objętych deklaracją. <br/>"
      }

      if (self.singleOrMultiFamily === "multi" && !self.isAllPremises && parseInt(self.multiFamilyCount) < parseInt(self.premisesCount)) {
        errors.premisesCount = true;
        errors.atLeastOne = true;
        text += "Liczba lokali objętych deklaracją nie może być większa niż liczba wszystkich lokali. <br/>";
      }

      if (self.singleOrMultiFamily === "isTemporary" && !self.isAllPremises && parseInt(self.temporaryCount) < parseInt(self.premisesCount)) {
        errors.premisesCount = true;
        errors.atLeastOne = true;
        text += "Liczba lokali objętych deklaracją nie może być większa wieksza niż liczba wszystkich lokali. <br/>";
      }
    }

    if (self.declarationType === "B") {
      if (self.selectedBuildingTypes.filter(b => !!b.selected).length <= 0) {
        errors.atLeastOne = true;
        errors.atLeastOneBuildingType = true;
        text += "Należy zaznaczyć przynajmniej jeden rodzaj budynku / lokalu. <br/>";
      }
    }

    if (!self.isAllPremises && !self.premisesList.length) {
      errors.premisesList = true;
      errors.atLeastOne = true;
      text += "Prosimy o podanie numerów lokali mieszkalnych / zbiorowego zamieszkania objętych deklaracją. <br/>"
    }

    if (errors.atLeastOne) {
      utils.showMessage(self, text);
    }
    return errors;
  }
}
